import Sidebar from "./Sidebar";
import ChatbotWidget from "./ChatbotWidget";
import { useAuth } from "../contexts/AuthContext";
import { useLocation } from "react-router-dom";

export default function Layout({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  return (
    <div className="flex min-h-screen bg-background text-foreground">
      <Sidebar />
      <main className="flex-1 min-w-0 relative">
        <div className="lg:hidden h-14" aria-hidden="true"/>
        {children}
        {user && !isAdmin && <ChatbotWidget />}
      </main>
    </div>
  );
}
